//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DispatcherCallbacksClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8781";

    }

    success(model: CalculationCompletedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/dispatcher-callback/success";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuccess(_response);
        });
    }

    protected processSuccess(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateRowDataElastic( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/dispatcher-callback/elastic-row-test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRowDataElastic(_response);
        });
    }

    protected processUpdateRowDataElastic(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    error(model: CalculationFailedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/dispatcher-callback/error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processError(_response);
        });
    }

    protected processError(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ExportDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8781";

    }

    generateExcel(model: GenerateExcelRequestModel, cancelToken?: CancelToken): Promise<GenerateExcelResponseModel> {
        let url_ = this.baseUrl + "/api/export-data/excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateExcel(_response);
        });
    }

    protected processGenerateExcel(response: AxiosResponse): Promise<GenerateExcelResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateExcelResponseModel.fromJS(resultData200);
            return Promise.resolve<GenerateExcelResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateExcelResponseModel>(null as any);
    }

    getStatus(requestId: string, cancelToken?: CancelToken): Promise<ExportDataStatus> {
        let url_ = this.baseUrl + "/api/export-data/status/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<ExportDataStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportDataStatus.fromJS(resultData200);
            return Promise.resolve<ExportDataStatus>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportDataStatus>(null as any);
    }
}

export class PrintReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8781";

    }

    getSensitivityStudyReport(studyId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/print-report/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSensitivityStudyReport(_response);
        });
    }

    protected processGetSensitivityStudyReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProcessingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8781";

    }

    startProcessing(model: ProcessingPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartProcessing(_response);
        });
    }

    protected processStartProcessing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    stopProcessing(model: ProcessingPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopProcessing(_response);
        });
    }

    protected processStopProcessing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resubmitRow(model: ResubmitRowPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/resubmit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResubmitRow(_response);
        });
    }

    protected processResubmitRow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resubmitFailedRows(studyId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/processing/resubmit-failed-rows/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResubmitFailedRows(_response);
        });
    }

    protected processResubmitFailedRows(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SensitivityStudiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8781";

    }

    getSensitivityStudies(query: SensitivityStudyQuery, cancelToken?: CancelToken): Promise<SensitivityStudyResultModel[]> {
        let url_ = this.baseUrl + "/api/sensitivity-studies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSensitivityStudies(_response);
        });
    }

    protected processGetSensitivityStudies(response: AxiosResponse): Promise<SensitivityStudyResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensitivityStudyResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SensitivityStudyResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyResultModel[]>(null as any);
    }

    createPDFReport(model: CreatePDFReportPostModel, cancelToken?: CancelToken): Promise<PDFReportCreatedResponseModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/create-pdf-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePDFReport(_response);
        });
    }

    protected processCreatePDFReport(response: AxiosResponse): Promise<PDFReportCreatedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PDFReportCreatedResponseModel.fromJS(resultData200);
            return Promise.resolve<PDFReportCreatedResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PDFReportCreatedResponseModel>(null as any);
    }

    getAllUserSensitivityStudies(query: UserSensitivityStudyQuery, cancelToken?: CancelToken): Promise<SensitivityStudyListResponseModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/all-user-studies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserSensitivityStudies(_response);
        });
    }

    protected processGetAllUserSensitivityStudies(response: AxiosResponse): Promise<SensitivityStudyListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SensitivityStudyListResponseModel.fromJS(resultData200);
            return Promise.resolve<SensitivityStudyListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyListResponseModel>(null as any);
    }

    getSensitivityStudy(studyId: number, query: SensitivityStudyQuery, cancelToken?: CancelToken): Promise<SensitivityStudyResultModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSensitivityStudy(_response);
        });
    }

    protected processGetSensitivityStudy(response: AxiosResponse): Promise<SensitivityStudyResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SensitivityStudyResultModel.fromJS(resultData200);
            return Promise.resolve<SensitivityStudyResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyResultModel>(null as any);
    }

    deleteStudy(studyId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudy(_response);
        });
    }

    protected processDeleteStudy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSensitivityStudyById(studyId: number, cancelToken?: CancelToken): Promise<SensitivityStudyResultModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/get-study-by-id/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSensitivityStudyById(_response);
        });
    }

    protected processGetSensitivityStudyById(response: AxiosResponse): Promise<SensitivityStudyResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SensitivityStudyResultModel.fromJS(resultData200);
            return Promise.resolve<SensitivityStudyResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyResultModel>(null as any);
    }

    createOrUpdateStudy(model: SensitivityStudyPostModel, cancelToken?: CancelToken): Promise<SensitivityStudyResultModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateStudy(_response);
        });
    }

    protected processCreateOrUpdateStudy(response: AxiosResponse): Promise<SensitivityStudyResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SensitivityStudyResultModel.fromJS(resultData200);
            return Promise.resolve<SensitivityStudyResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyResultModel>(null as any);
    }

    getStudyIdsByFilterId(filterId: number, cancelToken?: CancelToken): Promise<FilterStudyIdsResponseModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/by-filter-Id/{filterId}";
        if (filterId === undefined || filterId === null)
            throw new Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyIdsByFilterId(_response);
        });
    }

    protected processGetStudyIdsByFilterId(response: AxiosResponse): Promise<FilterStudyIdsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterStudyIdsResponseModel.fromJS(resultData200);
            return Promise.resolve<FilterStudyIdsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterStudyIdsResponseModel>(null as any);
    }

    cloneSharedStudy(model: CloneSharedStudyPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/clone-shared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneSharedStudy(_response);
        });
    }

    protected processCloneSharedStudy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    restoreStudy(studyId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/{studyId}/restore";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreStudy(_response);
        });
    }

    protected processRestoreStudy(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSensitivityStudyData(query: SensitivityStudyDataQuery, cancelToken?: CancelToken): Promise<SensitivityStudyDataResultModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSensitivityStudyData(_response);
        });
    }

    protected processGetSensitivityStudyData(response: AxiosResponse): Promise<SensitivityStudyDataResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SensitivityStudyDataResultModel.fromJS(resultData200);
            return Promise.resolve<SensitivityStudyDataResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyDataResultModel>(null as any);
    }

    cloneStudies(model: CloneStudiesPostModel, cancelToken?: CancelToken): Promise<CloneStudiesResponseModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/clone-multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneStudies(_response);
        });
    }

    protected processCloneStudies(response: AxiosResponse): Promise<CloneStudiesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloneStudiesResponseModel.fromJS(resultData200);
            return Promise.resolve<CloneStudiesResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloneStudiesResponseModel>(null as any);
    }

    getSensitivityStudyDataElastic(userQuery: SensitivityStudyDataQuery, cancelToken?: CancelToken): Promise<SensitivityStudyDataResultModel> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/data-elastic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userQuery);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSensitivityStudyDataElastic(_response);
        });
    }

    protected processGetSensitivityStudyDataElastic(response: AxiosResponse): Promise<SensitivityStudyDataResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SensitivityStudyDataResultModel.fromJS(resultData200);
            return Promise.resolve<SensitivityStudyDataResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyDataResultModel>(null as any);
    }

    getOptimumTestGraphData(studyId: number, studyVersionId: number, cancelToken?: CancelToken): Promise<GraphResult[]> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/{studyId}/version/{studyVersionId}/optimum-test-graph-data";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (studyVersionId === undefined || studyVersionId === null)
            throw new Error("The parameter 'studyVersionId' must be defined.");
        url_ = url_.replace("{studyVersionId}", encodeURIComponent("" + studyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOptimumTestGraphData(_response);
        });
    }

    protected processGetOptimumTestGraphData(response: AxiosResponse): Promise<GraphResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GraphResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GraphResult[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GraphResult[]>(null as any);
    }

    getStudyGraphData(studyId: number, studyVersionId: number, cancelToken?: CancelToken): Promise<RowElasticModel[]> {
        let url_ = this.baseUrl + "/api/sensitivity-studies/{studyId}/version/{studyVersionId}/study-graph-data";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (studyVersionId === undefined || studyVersionId === null)
            throw new Error("The parameter 'studyVersionId' must be defined.");
        url_ = url_.replace("{studyVersionId}", encodeURIComponent("" + studyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudyGraphData(_response);
        });
    }

    protected processGetStudyGraphData(response: AxiosResponse): Promise<RowElasticModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RowElasticModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RowElasticModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RowElasticModel[]>(null as any);
    }

    reindexDetectionsInElasticsearch( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReindexDetectionsInElasticsearch(_response);
        });
    }

    protected processReindexDetectionsInElasticsearch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getReindexRequests( cancelToken?: CancelToken): Promise<ReindexingRunModel[]> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex-requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReindexRequests(_response);
        });
    }

    protected processGetReindexRequests(response: AxiosResponse): Promise<ReindexingRunModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReindexingRunModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReindexingRunModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReindexingRunModel[]>(null as any);
    }

    getReindexRequest(requestId: string, cancelToken?: CancelToken): Promise<ReindexingRunModel> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex-requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReindexRequest(_response);
        });
    }

    protected processGetReindexRequest(response: AxiosResponse): Promise<ReindexingRunModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReindexingRunModel.fromJS(resultData200);
            return Promise.resolve<ReindexingRunModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReindexingRunModel>(null as any);
    }
}

export class ServiceInformationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8781";

    }

    getBuildDate( cancelToken?: CancelToken): Promise<ServiceInformationModel> {
        let url_ = this.baseUrl + "/api/serviceInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildDate(_response);
        });
    }

    protected processGetBuildDate(response: AxiosResponse): Promise<ServiceInformationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceInformationModel.fromJS(resultData200);
            return Promise.resolve<ServiceInformationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceInformationModel>(null as any);
    }
}

export class StudiesCountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8781";

    }

    getStudiesCount(model: StudiesCountPostModel, cancelToken?: CancelToken): Promise<SensitivityStudyCountResultModel[]> {
        let url_ = this.baseUrl + "/api/studies-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudiesCount(_response);
        });
    }

    protected processGetStudiesCount(response: AxiosResponse): Promise<SensitivityStudyCountResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensitivityStudyCountResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SensitivityStudyCountResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyCountResultModel[]>(null as any);
    }

    getStudiesCountDashboardV2(model: StudiesCountPostModel, cancelToken?: CancelToken): Promise<SensitivityStudyCountResultModel[]> {
        let url_ = this.baseUrl + "/api/studies-count-v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudiesCountDashboardV2(_response);
        });
    }

    protected processGetStudiesCountDashboardV2(response: AxiosResponse): Promise<SensitivityStudyCountResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensitivityStudyCountResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SensitivityStudyCountResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyCountResultModel[]>(null as any);
    }

    getOptimumTestsCountDashboardV2(model: StudiesCountPostModel, cancelToken?: CancelToken): Promise<SensitivityStudyCountResultModel[]> {
        let url_ = this.baseUrl + "/api/optimum-tests-count-v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOptimumTestsCountDashboardV2(_response);
        });
    }

    protected processGetOptimumTestsCountDashboardV2(response: AxiosResponse): Promise<SensitivityStudyCountResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SensitivityStudyCountResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SensitivityStudyCountResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SensitivityStudyCountResultModel[]>(null as any);
    }

    getIndividualFlowsheetStudiesCount(fileUniqueId: string, studyType: StudyType, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueId}/studies-count/{studyType}";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        if (studyType === undefined || studyType === null)
            throw new Error("The parameter 'studyType' must be defined.");
        url_ = url_.replace("{studyType}", encodeURIComponent("" + studyType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndividualFlowsheetStudiesCount(_response);
        });
    }

    protected processGetIndividualFlowsheetStudiesCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CallbackModelBase implements ICallbackModelBase {
    jobId?: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;

    constructor(data?: ICallbackModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.flowsheetItemId = _data["flowsheetItemId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
        }
    }

    static fromJS(data: any): CallbackModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["flowsheetItemId"] = this.flowsheetItemId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        return data;
    }
}

export interface ICallbackModelBase {
    jobId?: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
}

export class CalculationCompletedCallbackModel extends CallbackModelBase implements ICalculationCompletedCallbackModel {
    simulator?: SimulatorType;
    outputParameters?: OutputParameterCallbackModel[] | undefined;

    constructor(data?: ICalculationCompletedCallbackModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.simulator = _data["simulator"];
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(OutputParameterCallbackModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationCompletedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCompletedCallbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simulator"] = this.simulator;
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICalculationCompletedCallbackModel extends ICallbackModelBase {
    simulator?: SimulatorType;
    outputParameters?: OutputParameterCallbackModel[] | undefined;
}

export enum SimulatorType {
    Chemcad7 = 1,
    DWSIM = 2,
    Chemcad8 = 3,
}

export class OutputParameterCallbackModel implements IOutputParameterCallbackModel {
    parameter?: string | undefined;
    value?: number;

    constructor(data?: IOutputParameterCallbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OutputParameterCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterCallbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IOutputParameterCallbackModel {
    parameter?: string | undefined;
    value?: number;
}

export class CalculationFailedCallbackModel extends CallbackModelBase implements ICalculationFailedCallbackModel {
    errorMessage?: string | undefined;

    constructor(data?: ICalculationFailedCallbackModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CalculationFailedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationFailedCallbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        super.toJSON(data);
        return data;
    }
}

export interface ICalculationFailedCallbackModel extends ICallbackModelBase {
    errorMessage?: string | undefined;
}

export class GenerateExcelResponseModel implements IGenerateExcelResponseModel {
    requestId?: string;

    constructor(data?: IGenerateExcelResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): GenerateExcelResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateExcelResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IGenerateExcelResponseModel {
    requestId?: string;
}

export class ErrorResultModel implements IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (<any>this.validationErrors)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (<any>data["validationErrors"])[key] = (<any>this.validationErrors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class GenerateExcelRequestModel implements IGenerateExcelRequestModel {
    studyId!: number;
    studyVersionId!: number;
    filename!: string;
    parentDirectoryUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;
    writeResults?: boolean;
    includeConvergedResults?: boolean;

    constructor(data?: IGenerateExcelRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.studyVersionId = _data["studyVersionId"];
            this.filename = _data["filename"];
            this.parentDirectoryUniqueId = _data["parentDirectoryUniqueId"];
            this.uploadConflictAction = _data["uploadConflictAction"];
            this.writeResults = _data["writeResults"];
            this.includeConvergedResults = _data["includeConvergedResults"];
        }
    }

    static fromJS(data: any): GenerateExcelRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateExcelRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["studyVersionId"] = this.studyVersionId;
        data["filename"] = this.filename;
        data["parentDirectoryUniqueId"] = this.parentDirectoryUniqueId;
        data["uploadConflictAction"] = this.uploadConflictAction;
        data["writeResults"] = this.writeResults;
        data["includeConvergedResults"] = this.includeConvergedResults;
        return data;
    }
}

export interface IGenerateExcelRequestModel {
    studyId: number;
    studyVersionId: number;
    filename: string;
    parentDirectoryUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;
    writeResults?: boolean;
    includeConvergedResults?: boolean;
}

export enum UploadConflictAction {
    Overwrite = 0,
    KeepBoth = 1,
}

export class ExportDataStatus implements IExportDataStatus {
    requestId?: string;
    filename?: string | undefined;
    filepath?: string | undefined;
    isGenerated?: boolean;

    constructor(data?: IExportDataStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.filename = _data["filename"];
            this.filepath = _data["filepath"];
            this.isGenerated = _data["isGenerated"];
        }
    }

    static fromJS(data: any): ExportDataStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDataStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["filename"] = this.filename;
        data["filepath"] = this.filepath;
        data["isGenerated"] = this.isGenerated;
        return data;
    }
}

export interface IExportDataStatus {
    requestId?: string;
    filename?: string | undefined;
    filepath?: string | undefined;
    isGenerated?: boolean;
}

export class ProcessingPostModel implements IProcessingPostModel {
    studyId?: number;

    constructor(data?: IProcessingPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
        }
    }

    static fromJS(data: any): ProcessingPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        return data;
    }
}

export interface IProcessingPostModel {
    studyId?: number;
}

export class ResubmitRowPostModel implements IResubmitRowPostModel {
    studyId!: number;
    rowId!: number;

    constructor(data?: IResubmitRowPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.rowId = _data["rowId"];
        }
    }

    static fromJS(data: any): ResubmitRowPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitRowPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["rowId"] = this.rowId;
        return data;
    }
}

export interface IResubmitRowPostModel {
    studyId: number;
    rowId: number;
}

export class SensitivityStudyResultModel implements ISensitivityStudyResultModel {
    id?: number;
    name?: string | undefined;
    flowsheetDriveId?: string | undefined;
    fileVersionId?: string | undefined;
    currentVersionId?: number | undefined;
    totalJobs?: number | undefined;
    calculatedRows?: number;
    failedRows?: number;
    optimalRowId?: number | undefined;
    studyType?: StudyType;
    studyParamterRange?: StudyParamterRange;
    currentStep?: StudyStep;
    currentStepStatus?: StudyStepStatus;
    inputConstraints?: string | undefined;
    outputConstraints?: string | undefined;
    createdAt?: Date;
    optimizationFunction?: string | undefined;
    optimizationFunctionAlias?: string | undefined;
    searchFor?: SearchFor;
    filterId?: number;
    filterVersionId?: number;
    errorMessage?: string | undefined;
    isDeleted?: boolean;
    sensitivityStudyInputParameters?: SensitivityStudyInputParameterPostModel[] | undefined;
    sensitivityStudyOutputParameters?: SensitivityStudyOutputParameterPostModel[] | undefined;

    constructor(data?: ISensitivityStudyResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.fileVersionId = _data["fileVersionId"];
            this.currentVersionId = _data["currentVersionId"];
            this.totalJobs = _data["totalJobs"];
            this.calculatedRows = _data["calculatedRows"];
            this.failedRows = _data["failedRows"];
            this.optimalRowId = _data["optimalRowId"];
            this.studyType = _data["studyType"];
            this.studyParamterRange = _data["studyParamterRange"];
            this.currentStep = _data["currentStep"];
            this.currentStepStatus = _data["currentStepStatus"];
            this.inputConstraints = _data["inputConstraints"];
            this.outputConstraints = _data["outputConstraints"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.optimizationFunction = _data["optimizationFunction"];
            this.optimizationFunctionAlias = _data["optimizationFunctionAlias"];
            this.searchFor = _data["searchFor"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.errorMessage = _data["errorMessage"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["sensitivityStudyInputParameters"])) {
                this.sensitivityStudyInputParameters = [] as any;
                for (let item of _data["sensitivityStudyInputParameters"])
                    this.sensitivityStudyInputParameters!.push(SensitivityStudyInputParameterPostModel.fromJS(item));
            }
            if (Array.isArray(_data["sensitivityStudyOutputParameters"])) {
                this.sensitivityStudyOutputParameters = [] as any;
                for (let item of _data["sensitivityStudyOutputParameters"])
                    this.sensitivityStudyOutputParameters!.push(SensitivityStudyOutputParameterPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SensitivityStudyResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["fileVersionId"] = this.fileVersionId;
        data["currentVersionId"] = this.currentVersionId;
        data["totalJobs"] = this.totalJobs;
        data["calculatedRows"] = this.calculatedRows;
        data["failedRows"] = this.failedRows;
        data["optimalRowId"] = this.optimalRowId;
        data["studyType"] = this.studyType;
        data["studyParamterRange"] = this.studyParamterRange;
        data["currentStep"] = this.currentStep;
        data["currentStepStatus"] = this.currentStepStatus;
        data["inputConstraints"] = this.inputConstraints;
        data["outputConstraints"] = this.outputConstraints;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["optimizationFunction"] = this.optimizationFunction;
        data["optimizationFunctionAlias"] = this.optimizationFunctionAlias;
        data["searchFor"] = this.searchFor;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["errorMessage"] = this.errorMessage;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.sensitivityStudyInputParameters)) {
            data["sensitivityStudyInputParameters"] = [];
            for (let item of this.sensitivityStudyInputParameters)
                data["sensitivityStudyInputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.sensitivityStudyOutputParameters)) {
            data["sensitivityStudyOutputParameters"] = [];
            for (let item of this.sensitivityStudyOutputParameters)
                data["sensitivityStudyOutputParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISensitivityStudyResultModel {
    id?: number;
    name?: string | undefined;
    flowsheetDriveId?: string | undefined;
    fileVersionId?: string | undefined;
    currentVersionId?: number | undefined;
    totalJobs?: number | undefined;
    calculatedRows?: number;
    failedRows?: number;
    optimalRowId?: number | undefined;
    studyType?: StudyType;
    studyParamterRange?: StudyParamterRange;
    currentStep?: StudyStep;
    currentStepStatus?: StudyStepStatus;
    inputConstraints?: string | undefined;
    outputConstraints?: string | undefined;
    createdAt?: Date;
    optimizationFunction?: string | undefined;
    optimizationFunctionAlias?: string | undefined;
    searchFor?: SearchFor;
    filterId?: number;
    filterVersionId?: number;
    errorMessage?: string | undefined;
    isDeleted?: boolean;
    sensitivityStudyInputParameters?: SensitivityStudyInputParameterPostModel[] | undefined;
    sensitivityStudyOutputParameters?: SensitivityStudyOutputParameterPostModel[] | undefined;
}

export enum StudyType {
    SensitivityStudy = 1,
    OptimumTest = 2,
}

export enum StudyParamterRange {
    MinMax = 0,
    InitialValueWithSteps = 1,
}

export enum StudyStep {
    CalculateInitialJob = 0,
    CreateJobs = 1,
    CalculateJobs = 2,
}

export enum StudyStepStatus {
    Ready = 0,
    InProgress = 1,
    Failed = 2,
    SuccessfullyFinished = 3,
    Stopped = 4,
}

export enum SearchFor {
    Min = 0,
    Max = 1,
}

export class SensitivityStudyInputParameterPostModel implements ISensitivityStudyInputParameterPostModel {
    id?: number;
    inputFilterParameterId?: number;
    valueType?: StudyInputParamterType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    stepSize?: number | undefined;
    value!: number;
    stepsBefore?: number | undefined;
    stepsAfter?: number | undefined;
    totalVariations?: number | undefined;
    sensitivityStudyId?: number;
    sensitivityStudy?: SensitivityStudyPostModel | undefined;

    constructor(data?: ISensitivityStudyInputParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inputFilterParameterId = _data["inputFilterParameterId"];
            this.valueType = _data["valueType"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.stepSize = _data["stepSize"];
            this.value = _data["value"];
            this.stepsBefore = _data["stepsBefore"];
            this.stepsAfter = _data["stepsAfter"];
            this.totalVariations = _data["totalVariations"];
            this.sensitivityStudyId = _data["sensitivityStudyId"];
            this.sensitivityStudy = _data["sensitivityStudy"] ? SensitivityStudyPostModel.fromJS(_data["sensitivityStudy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SensitivityStudyInputParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyInputParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inputFilterParameterId"] = this.inputFilterParameterId;
        data["valueType"] = this.valueType;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["stepSize"] = this.stepSize;
        data["value"] = this.value;
        data["stepsBefore"] = this.stepsBefore;
        data["stepsAfter"] = this.stepsAfter;
        data["totalVariations"] = this.totalVariations;
        data["sensitivityStudyId"] = this.sensitivityStudyId;
        data["sensitivityStudy"] = this.sensitivityStudy ? this.sensitivityStudy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISensitivityStudyInputParameterPostModel {
    id?: number;
    inputFilterParameterId?: number;
    valueType?: StudyInputParamterType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    stepSize?: number | undefined;
    value: number;
    stepsBefore?: number | undefined;
    stepsAfter?: number | undefined;
    totalVariations?: number | undefined;
    sensitivityStudyId?: number;
    sensitivityStudy?: SensitivityStudyPostModel | undefined;
}

export enum StudyInputParamterType {
    FixedValue = 0,
    Range = 1,
    FilterDefined = 2,
}

export class SensitivityStudyPostModel implements ISensitivityStudyPostModel {
    id?: number;
    name!: string;
    flowsheetDriveId!: string;
    driveId!: string;
    studyParamterRange!: StudyParamterRange;
    inputConstraints?: string | undefined;
    outputConstraints?: string | undefined;
    optimizationFunction!: string;
    optimizationFunctionAlias!: string;
    searchFor!: SearchFor;
    userId?: string | undefined;
    siteId!: string;
    flowsheetsListId!: string;
    filterId!: number;
    filterVersionId!: number;
    studyType!: StudyType;
    fileVersionId?: number;
    sensitivityStudyInputParameters?: SensitivityStudyInputParameterPostModel[] | undefined;
    sensitivityStudyOutputParameters?: SensitivityStudyOutputParameterPostModel[] | undefined;

    constructor(data?: ISensitivityStudyPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.driveId = _data["driveId"];
            this.studyParamterRange = _data["studyParamterRange"];
            this.inputConstraints = _data["inputConstraints"];
            this.outputConstraints = _data["outputConstraints"];
            this.optimizationFunction = _data["optimizationFunction"];
            this.optimizationFunctionAlias = _data["optimizationFunctionAlias"];
            this.searchFor = _data["searchFor"];
            this.userId = _data["userId"];
            this.siteId = _data["siteId"];
            this.flowsheetsListId = _data["flowsheetsListId"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.studyType = _data["studyType"];
            this.fileVersionId = _data["fileVersionId"];
            if (Array.isArray(_data["sensitivityStudyInputParameters"])) {
                this.sensitivityStudyInputParameters = [] as any;
                for (let item of _data["sensitivityStudyInputParameters"])
                    this.sensitivityStudyInputParameters!.push(SensitivityStudyInputParameterPostModel.fromJS(item));
            }
            if (Array.isArray(_data["sensitivityStudyOutputParameters"])) {
                this.sensitivityStudyOutputParameters = [] as any;
                for (let item of _data["sensitivityStudyOutputParameters"])
                    this.sensitivityStudyOutputParameters!.push(SensitivityStudyOutputParameterPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SensitivityStudyPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["driveId"] = this.driveId;
        data["studyParamterRange"] = this.studyParamterRange;
        data["inputConstraints"] = this.inputConstraints;
        data["outputConstraints"] = this.outputConstraints;
        data["optimizationFunction"] = this.optimizationFunction;
        data["optimizationFunctionAlias"] = this.optimizationFunctionAlias;
        data["searchFor"] = this.searchFor;
        data["userId"] = this.userId;
        data["siteId"] = this.siteId;
        data["flowsheetsListId"] = this.flowsheetsListId;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["studyType"] = this.studyType;
        data["fileVersionId"] = this.fileVersionId;
        if (Array.isArray(this.sensitivityStudyInputParameters)) {
            data["sensitivityStudyInputParameters"] = [];
            for (let item of this.sensitivityStudyInputParameters)
                data["sensitivityStudyInputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.sensitivityStudyOutputParameters)) {
            data["sensitivityStudyOutputParameters"] = [];
            for (let item of this.sensitivityStudyOutputParameters)
                data["sensitivityStudyOutputParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISensitivityStudyPostModel {
    id?: number;
    name: string;
    flowsheetDriveId: string;
    driveId: string;
    studyParamterRange: StudyParamterRange;
    inputConstraints?: string | undefined;
    outputConstraints?: string | undefined;
    optimizationFunction: string;
    optimizationFunctionAlias: string;
    searchFor: SearchFor;
    userId?: string | undefined;
    siteId: string;
    flowsheetsListId: string;
    filterId: number;
    filterVersionId: number;
    studyType: StudyType;
    fileVersionId?: number;
    sensitivityStudyInputParameters?: SensitivityStudyInputParameterPostModel[] | undefined;
    sensitivityStudyOutputParameters?: SensitivityStudyOutputParameterPostModel[] | undefined;
}

export class SensitivityStudyOutputParameterPostModel implements ISensitivityStudyOutputParameterPostModel {
    id?: number;
    outputFilterParameterId?: number;
    parameterType?: StudyOutputParamterType;

    constructor(data?: ISensitivityStudyOutputParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.outputFilterParameterId = _data["outputFilterParameterId"];
            this.parameterType = _data["parameterType"];
        }
    }

    static fromJS(data: any): SensitivityStudyOutputParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyOutputParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["outputFilterParameterId"] = this.outputFilterParameterId;
        data["parameterType"] = this.parameterType;
        return data;
    }
}

export interface ISensitivityStudyOutputParameterPostModel {
    id?: number;
    outputFilterParameterId?: number;
    parameterType?: StudyOutputParamterType;
}

export enum StudyOutputParamterType {
    ExpectedOutput = 0,
    FilterDefined = 1,
}

export class SensitivityStudyQuery implements ISensitivityStudyQuery {
    flowsheetDriveId?: string | undefined;
    siteId!: string;
    flowsheetsListId!: string;
    studyType?: StudyType;

    constructor(data?: ISensitivityStudyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.siteId = _data["siteId"];
            this.flowsheetsListId = _data["flowsheetsListId"];
            this.studyType = _data["studyType"];
        }
    }

    static fromJS(data: any): SensitivityStudyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["siteId"] = this.siteId;
        data["flowsheetsListId"] = this.flowsheetsListId;
        data["studyType"] = this.studyType;
        return data;
    }
}

export interface ISensitivityStudyQuery {
    flowsheetDriveId?: string | undefined;
    siteId: string;
    flowsheetsListId: string;
    studyType?: StudyType;
}

export class PDFReportCreatedResponseModel implements IPDFReportCreatedResponseModel {
    filename?: string | undefined;
    simulatePath?: string | undefined;

    constructor(data?: IPDFReportCreatedResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.simulatePath = _data["simulatePath"];
        }
    }

    static fromJS(data: any): PDFReportCreatedResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PDFReportCreatedResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["simulatePath"] = this.simulatePath;
        return data;
    }
}

export interface IPDFReportCreatedResponseModel {
    filename?: string | undefined;
    simulatePath?: string | undefined;
}

export class CreatePDFReportPostModel implements ICreatePDFReportPostModel {
    filename!: string;
    studyId!: number;
    conflictAction?: UploadConflictAction | undefined;
    parentUniqueIdentifier?: string | undefined;

    constructor(data?: ICreatePDFReportPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.studyId = _data["studyId"];
            this.conflictAction = _data["conflictAction"];
            this.parentUniqueIdentifier = _data["parentUniqueIdentifier"];
        }
    }

    static fromJS(data: any): CreatePDFReportPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePDFReportPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["studyId"] = this.studyId;
        data["conflictAction"] = this.conflictAction;
        data["parentUniqueIdentifier"] = this.parentUniqueIdentifier;
        return data;
    }
}

export interface ICreatePDFReportPostModel {
    filename: string;
    studyId: number;
    conflictAction?: UploadConflictAction | undefined;
    parentUniqueIdentifier?: string | undefined;
}

export class SensitivityStudyListResponseModel implements ISensitivityStudyListResponseModel {
    totalRecords?: number;
    studies?: SensitivityStudyResultModel[] | undefined;

    constructor(data?: ISensitivityStudyListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["studies"])) {
                this.studies = [] as any;
                for (let item of _data["studies"])
                    this.studies!.push(SensitivityStudyResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SensitivityStudyListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.studies)) {
            data["studies"] = [];
            for (let item of this.studies)
                data["studies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISensitivityStudyListResponseModel {
    totalRecords?: number;
    studies?: SensitivityStudyResultModel[] | undefined;
}

export class UserSensitivityStudyQuery implements IUserSensitivityStudyQuery {
    studyType?: StudyType;
    isDeleted?: boolean;
    skip?: number;
    take?: number;
    orderByIdDesc?: boolean;

    constructor(data?: IUserSensitivityStudyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyType = _data["studyType"];
            this.isDeleted = _data["isDeleted"];
            this.skip = _data["skip"];
            this.take = _data["take"];
            this.orderByIdDesc = _data["orderByIdDesc"];
        }
    }

    static fromJS(data: any): UserSensitivityStudyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserSensitivityStudyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyType"] = this.studyType;
        data["isDeleted"] = this.isDeleted;
        data["skip"] = this.skip;
        data["take"] = this.take;
        data["orderByIdDesc"] = this.orderByIdDesc;
        return data;
    }
}

export interface IUserSensitivityStudyQuery {
    studyType?: StudyType;
    isDeleted?: boolean;
    skip?: number;
    take?: number;
    orderByIdDesc?: boolean;
}

export class FilterStudyIdsResponseModel implements IFilterStudyIdsResponseModel {
    studyIds?: number[] | undefined;

    constructor(data?: IFilterStudyIdsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyIds"])) {
                this.studyIds = [] as any;
                for (let item of _data["studyIds"])
                    this.studyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterStudyIdsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterStudyIdsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyIds)) {
            data["studyIds"] = [];
            for (let item of this.studyIds)
                data["studyIds"].push(item);
        }
        return data;
    }
}

export interface IFilterStudyIdsResponseModel {
    studyIds?: number[] | undefined;
}

export class CloneSharedStudyPostModel implements ICloneSharedStudyPostModel {
    studyId!: number;
    filename!: string;
    shareSourceType!: ShareDefinitionSourceType;
    destinationUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;

    constructor(data?: ICloneSharedStudyPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.filename = _data["filename"];
            this.shareSourceType = _data["shareSourceType"];
            this.destinationUniqueId = _data["destinationUniqueId"];
            this.conflictAction = _data["conflictAction"];
        }
    }

    static fromJS(data: any): CloneSharedStudyPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneSharedStudyPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["filename"] = this.filename;
        data["shareSourceType"] = this.shareSourceType;
        data["destinationUniqueId"] = this.destinationUniqueId;
        data["conflictAction"] = this.conflictAction;
        return data;
    }
}

export interface ICloneSharedStudyPostModel {
    studyId: number;
    filename: string;
    shareSourceType: ShareDefinitionSourceType;
    destinationUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;
}

export enum ShareDefinitionSourceType {
    File = 0,
    Directory = 1,
    CopilotExperiment = 2,
    DoEExperiment = 3,
    MssStudy = 4,
    OptimumTest = 5,
    Filter = 6,
}

export class SensitivityStudyDataResultModel implements ISensitivityStudyDataResultModel {
    totalRecords?: number;
    rows?: RowModel[] | undefined;

    constructor(data?: ISensitivityStudyDataResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SensitivityStudyDataResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyDataResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISensitivityStudyDataResultModel {
    totalRecords?: number;
    rows?: RowModel[] | undefined;
}

export class RowModel implements IRowModel {
    id?: number;
    dispatcherJobId?: number | undefined;
    inputParameters?: RowInputParameterModel[] | undefined;
    results?: RowResultModel[] | undefined;
    processingStatus?: RowProcessingStatus;
    evaluationFunctionValue?: number | undefined;
    evaluationFunctionStatus?: EvaluationFunctionStatus;
    evaluationFunctionMessage?: string | undefined;

    constructor(data?: IRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dispatcherJobId = _data["dispatcherJobId"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(RowInputParameterModel.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RowResultModel.fromJS(item));
            }
            this.processingStatus = _data["processingStatus"];
            this.evaluationFunctionValue = _data["evaluationFunctionValue"];
            this.evaluationFunctionStatus = _data["evaluationFunctionStatus"];
            this.evaluationFunctionMessage = _data["evaluationFunctionMessage"];
        }
    }

    static fromJS(data: any): RowModel {
        data = typeof data === 'object' ? data : {};
        let result = new RowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dispatcherJobId"] = this.dispatcherJobId;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["processingStatus"] = this.processingStatus;
        data["evaluationFunctionValue"] = this.evaluationFunctionValue;
        data["evaluationFunctionStatus"] = this.evaluationFunctionStatus;
        data["evaluationFunctionMessage"] = this.evaluationFunctionMessage;
        return data;
    }
}

export interface IRowModel {
    id?: number;
    dispatcherJobId?: number | undefined;
    inputParameters?: RowInputParameterModel[] | undefined;
    results?: RowResultModel[] | undefined;
    processingStatus?: RowProcessingStatus;
    evaluationFunctionValue?: number | undefined;
    evaluationFunctionStatus?: EvaluationFunctionStatus;
    evaluationFunctionMessage?: string | undefined;
}

export class RowInputParameterModel implements IRowInputParameterModel {
    id?: number;
    rowId?: number;
    sensitivityStudyInputParameterId?: number;
    sensitivityStudyInputParameter?: SensitivityStudyInputParameterResultModel | undefined;
    value?: number;

    constructor(data?: IRowInputParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowId = _data["rowId"];
            this.sensitivityStudyInputParameterId = _data["sensitivityStudyInputParameterId"];
            this.sensitivityStudyInputParameter = _data["sensitivityStudyInputParameter"] ? SensitivityStudyInputParameterResultModel.fromJS(_data["sensitivityStudyInputParameter"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RowInputParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RowInputParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowId"] = this.rowId;
        data["sensitivityStudyInputParameterId"] = this.sensitivityStudyInputParameterId;
        data["sensitivityStudyInputParameter"] = this.sensitivityStudyInputParameter ? this.sensitivityStudyInputParameter.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IRowInputParameterModel {
    id?: number;
    rowId?: number;
    sensitivityStudyInputParameterId?: number;
    sensitivityStudyInputParameter?: SensitivityStudyInputParameterResultModel | undefined;
    value?: number;
}

export class SensitivityStudyInputParameterResultModel implements ISensitivityStudyInputParameterResultModel {
    id?: number;
    inputFilterParameterId?: number;
    valueType?: StudyInputParamterType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    stepSize?: number | undefined;
    value?: number;
    stepsBefore?: number | undefined;
    stepsAfter?: number | undefined;
    sensitivityStudyId?: number;

    constructor(data?: ISensitivityStudyInputParameterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inputFilterParameterId = _data["inputFilterParameterId"];
            this.valueType = _data["valueType"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.stepSize = _data["stepSize"];
            this.value = _data["value"];
            this.stepsBefore = _data["stepsBefore"];
            this.stepsAfter = _data["stepsAfter"];
            this.sensitivityStudyId = _data["sensitivityStudyId"];
        }
    }

    static fromJS(data: any): SensitivityStudyInputParameterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyInputParameterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inputFilterParameterId"] = this.inputFilterParameterId;
        data["valueType"] = this.valueType;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["stepSize"] = this.stepSize;
        data["value"] = this.value;
        data["stepsBefore"] = this.stepsBefore;
        data["stepsAfter"] = this.stepsAfter;
        data["sensitivityStudyId"] = this.sensitivityStudyId;
        return data;
    }
}

export interface ISensitivityStudyInputParameterResultModel {
    id?: number;
    inputFilterParameterId?: number;
    valueType?: StudyInputParamterType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    stepSize?: number | undefined;
    value?: number;
    stepsBefore?: number | undefined;
    stepsAfter?: number | undefined;
    sensitivityStudyId?: number;
}

export class RowResultModel implements IRowResultModel {
    id?: number;
    rowId?: number;
    sensitivityStudyOutputParameterId?: number;
    sensitivityStudyOutputParameter?: SensitivityStudyOutputParameterResultModel | undefined;
    value?: number;

    constructor(data?: IRowResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowId = _data["rowId"];
            this.sensitivityStudyOutputParameterId = _data["sensitivityStudyOutputParameterId"];
            this.sensitivityStudyOutputParameter = _data["sensitivityStudyOutputParameter"] ? SensitivityStudyOutputParameterResultModel.fromJS(_data["sensitivityStudyOutputParameter"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RowResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new RowResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowId"] = this.rowId;
        data["sensitivityStudyOutputParameterId"] = this.sensitivityStudyOutputParameterId;
        data["sensitivityStudyOutputParameter"] = this.sensitivityStudyOutputParameter ? this.sensitivityStudyOutputParameter.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IRowResultModel {
    id?: number;
    rowId?: number;
    sensitivityStudyOutputParameterId?: number;
    sensitivityStudyOutputParameter?: SensitivityStudyOutputParameterResultModel | undefined;
    value?: number;
}

export class SensitivityStudyOutputParameterResultModel implements ISensitivityStudyOutputParameterResultModel {
    id?: number;
    outputFilterParameterId?: number;

    constructor(data?: ISensitivityStudyOutputParameterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.outputFilterParameterId = _data["outputFilterParameterId"];
        }
    }

    static fromJS(data: any): SensitivityStudyOutputParameterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyOutputParameterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["outputFilterParameterId"] = this.outputFilterParameterId;
        return data;
    }
}

export interface ISensitivityStudyOutputParameterResultModel {
    id?: number;
    outputFilterParameterId?: number;
}

export enum RowProcessingStatus {
    NotSubmittedToDispatcher = 0,
    SubmittedToDispatcher = 1,
    Calculated = 2,
    CalculationFailed = 3,
    ProcessingFailed = 4,
    ReceivedResults = 5,
    PostProcessingFailed = 6,
    OutputConstraintViolated = 7,
}

export enum EvaluationFunctionStatus {
    NotEvaluated = 0,
    Evaluated = 1,
    Failed = 2,
}

export class SensitivityStudyDataQuery implements ISensitivityStudyDataQuery {
    sensitivityStudyId!: number;
    studyType!: StudyType;
    sensitivityStudyVersionId!: number;
    processingStatus?: RowProcessingStatus | undefined;
    parameterFilter?: ParameterFilter | undefined;
    rowId?: number | undefined;
    dispatcherJobId?: number | undefined;
    orderBy?: string | undefined;
    orderByDescending?: boolean;
    skip?: number;
    take?: number;

    constructor(data?: ISensitivityStudyDataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sensitivityStudyId = _data["sensitivityStudyId"];
            this.studyType = _data["studyType"];
            this.sensitivityStudyVersionId = _data["sensitivityStudyVersionId"];
            this.processingStatus = _data["processingStatus"];
            this.parameterFilter = _data["parameterFilter"] ? ParameterFilter.fromJS(_data["parameterFilter"]) : <any>undefined;
            this.rowId = _data["rowId"];
            this.dispatcherJobId = _data["dispatcherJobId"];
            this.orderBy = _data["orderBy"];
            this.orderByDescending = _data["orderByDescending"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): SensitivityStudyDataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyDataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sensitivityStudyId"] = this.sensitivityStudyId;
        data["studyType"] = this.studyType;
        data["sensitivityStudyVersionId"] = this.sensitivityStudyVersionId;
        data["processingStatus"] = this.processingStatus;
        data["parameterFilter"] = this.parameterFilter ? this.parameterFilter.toJSON() : <any>undefined;
        data["rowId"] = this.rowId;
        data["dispatcherJobId"] = this.dispatcherJobId;
        data["orderBy"] = this.orderBy;
        data["orderByDescending"] = this.orderByDescending;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface ISensitivityStudyDataQuery {
    sensitivityStudyId: number;
    studyType: StudyType;
    sensitivityStudyVersionId: number;
    processingStatus?: RowProcessingStatus | undefined;
    parameterFilter?: ParameterFilter | undefined;
    rowId?: number | undefined;
    dispatcherJobId?: number | undefined;
    orderBy?: string | undefined;
    orderByDescending?: boolean;
    skip?: number;
    take?: number;
}

export class ParameterFilter implements IParameterFilter {
    parameterId?: string | undefined;
    filterOperation?: FilterOperation;
    equalsValue?: number | undefined;
    endsValue?: number | undefined;

    constructor(data?: IParameterFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterId = _data["parameterId"];
            this.filterOperation = _data["filterOperation"];
            this.equalsValue = _data["equalsValue"];
            this.endsValue = _data["endsValue"];
        }
    }

    static fromJS(data: any): ParameterFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterId"] = this.parameterId;
        data["filterOperation"] = this.filterOperation;
        data["equalsValue"] = this.equalsValue;
        data["endsValue"] = this.endsValue;
        return data;
    }
}

export interface IParameterFilter {
    parameterId?: string | undefined;
    filterOperation?: FilterOperation;
    equalsValue?: number | undefined;
    endsValue?: number | undefined;
}

export enum FilterOperation {
    Equals = 0,
    Between = 1,
}

export class CloneStudiesResponseModel implements ICloneStudiesResponseModel {
    errors?: string[] | undefined;

    constructor(data?: ICloneStudiesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): CloneStudiesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneStudiesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface ICloneStudiesResponseModel {
    errors?: string[] | undefined;
}

export class CloneStudiesPostModel implements ICloneStudiesPostModel {
    fileUniqueId!: string;
    studies?: CloneStudyModel[] | undefined;

    constructor(data?: ICloneStudiesPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueId = _data["fileUniqueId"];
            if (Array.isArray(_data["studies"])) {
                this.studies = [] as any;
                for (let item of _data["studies"])
                    this.studies!.push(CloneStudyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CloneStudiesPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneStudiesPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueId"] = this.fileUniqueId;
        if (Array.isArray(this.studies)) {
            data["studies"] = [];
            for (let item of this.studies)
                data["studies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICloneStudiesPostModel {
    fileUniqueId: string;
    studies?: CloneStudyModel[] | undefined;
}

export class CloneStudyModel implements ICloneStudyModel {
    studyId!: number;
    filterId!: number;
    filterVersionId!: number;

    constructor(data?: ICloneStudyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
        }
    }

    static fromJS(data: any): CloneStudyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneStudyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        return data;
    }
}

export interface ICloneStudyModel {
    studyId: number;
    filterId: number;
    filterVersionId: number;
}

export class GraphResult implements IGraphResult {
    inputParameterId?: number;
    parameterInfo?: ParameterInfo | undefined;
    data?: GraphValue[] | undefined;

    constructor(data?: IGraphResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputParameterId = _data["inputParameterId"];
            this.parameterInfo = _data["parameterInfo"] ? ParameterInfo.fromJS(_data["parameterInfo"]) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GraphValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GraphResult {
        data = typeof data === 'object' ? data : {};
        let result = new GraphResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputParameterId"] = this.inputParameterId;
        data["parameterInfo"] = this.parameterInfo ? this.parameterInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGraphResult {
    inputParameterId?: number;
    parameterInfo?: ParameterInfo | undefined;
    data?: GraphValue[] | undefined;
}

export class ParameterInfo implements IParameterInfo {
    id?: string | undefined;
    unitOperation?: string | undefined;
    stream?: string | undefined;
    component?: string | undefined;
    parameterName?: string | undefined;
    parameterUnit?: string | undefined;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitOperation = _data["unitOperation"];
            this.stream = _data["stream"];
            this.component = _data["component"];
            this.parameterName = _data["parameterName"];
            this.parameterUnit = _data["parameterUnit"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitOperation"] = this.unitOperation;
        data["stream"] = this.stream;
        data["component"] = this.component;
        data["parameterName"] = this.parameterName;
        data["parameterUnit"] = this.parameterUnit;
        return data;
    }
}

export interface IParameterInfo {
    id?: string | undefined;
    unitOperation?: string | undefined;
    stream?: string | undefined;
    component?: string | undefined;
    parameterName?: string | undefined;
    parameterUnit?: string | undefined;
}

export class GraphValue implements IGraphValue {
    x?: number;
    y?: number;
    isInitialValue?: boolean;

    constructor(data?: IGraphValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.isInitialValue = _data["isInitialValue"];
        }
    }

    static fromJS(data: any): GraphValue {
        data = typeof data === 'object' ? data : {};
        let result = new GraphValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["isInitialValue"] = this.isInitialValue;
        return data;
    }
}

export interface IGraphValue {
    x?: number;
    y?: number;
    isInitialValue?: boolean;
}

export class RowElasticModel implements IRowElasticModel {
    id?: number;
    dispatcherJobId?: number | undefined;
    processingStatus?: RowProcessingStatus;
    evaluationFunctionValue?: number | undefined;
    evaluationFunctionStatus?: EvaluationFunctionStatus;
    evaluationFunctionMessage?: string | undefined;
    parameters?: { [key: string]: ParameterElasticModel; } | undefined;
    sensitivityStudyId?: number;
    sensitivityStudyVersionId?: number;
    userId?: string | undefined;

    constructor(data?: IRowElasticModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dispatcherJobId = _data["dispatcherJobId"];
            this.processingStatus = _data["processingStatus"];
            this.evaluationFunctionValue = _data["evaluationFunctionValue"];
            this.evaluationFunctionStatus = _data["evaluationFunctionStatus"];
            this.evaluationFunctionMessage = _data["evaluationFunctionMessage"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key] ? ParameterElasticModel.fromJS(_data["parameters"][key]) : new ParameterElasticModel();
                }
            }
            this.sensitivityStudyId = _data["sensitivityStudyId"];
            this.sensitivityStudyVersionId = _data["sensitivityStudyVersionId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RowElasticModel {
        data = typeof data === 'object' ? data : {};
        let result = new RowElasticModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dispatcherJobId"] = this.dispatcherJobId;
        data["processingStatus"] = this.processingStatus;
        data["evaluationFunctionValue"] = this.evaluationFunctionValue;
        data["evaluationFunctionStatus"] = this.evaluationFunctionStatus;
        data["evaluationFunctionMessage"] = this.evaluationFunctionMessage;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = this.parameters[key] ? this.parameters[key].toJSON() : <any>undefined;
            }
        }
        data["sensitivityStudyId"] = this.sensitivityStudyId;
        data["sensitivityStudyVersionId"] = this.sensitivityStudyVersionId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IRowElasticModel {
    id?: number;
    dispatcherJobId?: number | undefined;
    processingStatus?: RowProcessingStatus;
    evaluationFunctionValue?: number | undefined;
    evaluationFunctionStatus?: EvaluationFunctionStatus;
    evaluationFunctionMessage?: string | undefined;
    parameters?: { [key: string]: ParameterElasticModel; } | undefined;
    sensitivityStudyId?: number;
    sensitivityStudyVersionId?: number;
    userId?: string | undefined;
}

export class ParameterElasticModel implements IParameterElasticModel {
    value?: number;
    sensitivityStudyParameterId?: number;

    constructor(data?: IParameterElasticModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.sensitivityStudyParameterId = _data["sensitivityStudyParameterId"];
        }
    }

    static fromJS(data: any): ParameterElasticModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterElasticModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["sensitivityStudyParameterId"] = this.sensitivityStudyParameterId;
        return data;
    }
}

export interface IParameterElasticModel {
    value?: number;
    sensitivityStudyParameterId?: number;
}

export class ReindexingRunModel implements IReindexingRunModel {
    uniqueId?: string;
    type?: string | undefined;
    batchSize?: number;
    totalItemsCount?: number;
    startedAt?: Date;
    status?: RunningStatus;
    message?: string | undefined;
    lastProcessedId?: number | undefined;
    processedItemsCount?: number;
    processedPercentage?: number | undefined;
    overallAverageDurationPerIteration?: number;
    sqlAverageDurationPerIteration?: number;
    indexAverageDurationPerIteration?: number;
    timeLeftStr?: string | undefined;

    constructor(data?: IReindexingRunModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.type = _data["type"];
            this.batchSize = _data["batchSize"];
            this.totalItemsCount = _data["totalItemsCount"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
            this.lastProcessedId = _data["lastProcessedId"];
            this.processedItemsCount = _data["processedItemsCount"];
            this.processedPercentage = _data["processedPercentage"];
            this.overallAverageDurationPerIteration = _data["overallAverageDurationPerIteration"];
            this.sqlAverageDurationPerIteration = _data["sqlAverageDurationPerIteration"];
            this.indexAverageDurationPerIteration = _data["indexAverageDurationPerIteration"];
            this.timeLeftStr = _data["timeLeftStr"];
        }
    }

    static fromJS(data: any): ReindexingRunModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReindexingRunModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["type"] = this.type;
        data["batchSize"] = this.batchSize;
        data["totalItemsCount"] = this.totalItemsCount;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        data["lastProcessedId"] = this.lastProcessedId;
        data["processedItemsCount"] = this.processedItemsCount;
        data["processedPercentage"] = this.processedPercentage;
        data["overallAverageDurationPerIteration"] = this.overallAverageDurationPerIteration;
        data["sqlAverageDurationPerIteration"] = this.sqlAverageDurationPerIteration;
        data["indexAverageDurationPerIteration"] = this.indexAverageDurationPerIteration;
        data["timeLeftStr"] = this.timeLeftStr;
        return data;
    }
}

export interface IReindexingRunModel {
    uniqueId?: string;
    type?: string | undefined;
    batchSize?: number;
    totalItemsCount?: number;
    startedAt?: Date;
    status?: RunningStatus;
    message?: string | undefined;
    lastProcessedId?: number | undefined;
    processedItemsCount?: number;
    processedPercentage?: number | undefined;
    overallAverageDurationPerIteration?: number;
    sqlAverageDurationPerIteration?: number;
    indexAverageDurationPerIteration?: number;
    timeLeftStr?: string | undefined;
}

export enum RunningStatus {
    Running = 0,
    Finished = 1,
    Failed = 2,
}

export class ServiceInformationModel implements IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;

    constructor(data?: IServiceInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildDate = _data["buildDate"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ServiceInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildDate"] = this.buildDate;
        data["version"] = this.version;
        return data;
    }
}

export interface IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;
}

export class SensitivityStudyCountResultModel implements ISensitivityStudyCountResultModel {
    driveItemId?: string | undefined;
    count?: number;

    constructor(data?: ISensitivityStudyCountResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driveItemId = _data["driveItemId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): SensitivityStudyCountResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SensitivityStudyCountResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveItemId"] = this.driveItemId;
        data["count"] = this.count;
        return data;
    }
}

export interface ISensitivityStudyCountResultModel {
    driveItemId?: string | undefined;
    count?: number;
}

export class StudiesCountPostModel implements IStudiesCountPostModel {
    driveItemIds?: string[] | undefined;

    constructor(data?: IStudiesCountPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["driveItemIds"])) {
                this.driveItemIds = [] as any;
                for (let item of _data["driveItemIds"])
                    this.driveItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StudiesCountPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudiesCountPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.driveItemIds)) {
            data["driveItemIds"] = [];
            for (let item of this.driveItemIds)
                data["driveItemIds"].push(item);
        }
        return data;
    }
}

export interface IStudiesCountPostModel {
    driveItemIds?: string[] | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}